import {
  ApiResponse,
  InitOverrideFunction,
  SummaryApi,
  SummaryCancelSummarizationPostRequest,
  SummarySummarizeTextFilePostRequest,
} from "../../../@api";

import { IStoreContext } from "../../stores/StoreContext";
import { SummaryApiService } from "../ApiServices/SummaryApiService";
import GenericService from "../GenericService";

export class SummaryService extends GenericService<SummaryApi, SummaryApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, SummaryApi, SummaryApiService);
  }

  public async summarize(
    file: SummarySummarizeTextFilePostRequest,
    overrides: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.apiService.summarySummarizeTextFilePostRaw(file, overrides);
  }

  public async cancelActiveSummarization(request: SummaryCancelSummarizationPostRequest): Promise<string> {
    return this.apiService.summaryCancelSummarizationPost(request);
  }
}
